import React, { useEffect, useCallback, useState} from 'react';
import DetailsView from "components/DetailsView.js";
import {connect} from 'react-redux';

const MIN_WIDTH = 180;

const PadWaveform = ({div, pad, selectedTrack}) => { 
    let track = pad.slotTracks.find(x => x.trackNumber === selectedTrack);
    let [width, setWidth] = useState(pad.width || 300);
    let [mouseDown, setMouseDown] = useState(undefined);

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [mouseDown, setWidth, onMouseUp]);

    const onMouseUp = useCallback((e) => {
        setMouseDown(false);
    }, [setMouseDown]);

    const onMouseMove = useCallback((e) => {
        if (!mouseDown) {
            return;
        }
        let rect = div.current.getBoundingClientRect();
        let x = e.clientX - rect.left;
        if (x < MIN_WIDTH) {
            return;
        }
        pad.width = x;
        setWidth(x);
    }, [mouseDown, setWidth]);
    if (!track) {
        return [];
    }
    return (
        <div className="pad-waveform">
          <DetailsView.DetailsView
            width={width}
            div={div}
            small={true}
            showParameters={false}
            hideKeyboard={true}
            alreadyLoaded={true}
            onGoBack={() => []}
            keyboardEngine={pad.sequencerEngine.keyboardEngine}
            midiEngine={pad.sequencerEngine.midi}
            trackNumber={pad.sequencerEngine.cursor.track}
            resolution={pad.sequencerEngine.resolution}
            height={120}
            sequencerEngine={pad.sequencerEngine}
            bpm={pad.sequencerEngine.bpm}
            track={track}/>
          <div onMouseDown={(e) => {
              e.stopPropagation();
              setMouseDown(true);
          }} className="waveform-resizer">
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let track = props.pad.sequencerEngine.tracks[state.mix.selectedTrack];
    return {
        selectedTrack: state.mix.selectedTrack,
        loaded: track && track.getSampler(0),
        tracks: props.pad.tracks
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadWaveform);
